// Servicio para testimonios - desde API/BD (javiland_testimonials)
const API_BASE = process.env.REACT_APP_API_URL || '/api';

class TestimonialsService {
  async fetchTestimonials(category = null) {
    try {
      const url = category 
        ? `${API_BASE}/testimonials?category=${encodeURIComponent(category)}`
        : `${API_BASE}/testimonials`;
      const response = await fetch(url);
      
      if (!response.ok) throw new Error(`Error al obtener testimonios: ${response.status}`);
      
      const data = await response.json();
      const items = data?.testimonials ?? data ?? [];
      
      if (Array.isArray(items) && items.length > 0) {
        return items.map(t => ({
          ...t,
          date: t.created_at ? t.created_at.split('T')[0] : t.date,
          status: 'aprobado'
        }));
      }
      
      return this.getMockTestimonials();
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      return this.getMockTestimonials();
    }
  }

  // Esta función ya no es necesaria porque Google Apps Script procesa los datos

  getMockTestimonials() {
    // Datos simulados como fallback
    return [
      {
        id: 1,
        name: 'María G.',
        category: 'ecommerce',
        rating: 5,
        message: 'La tienda de Javiland es increíble. Los productos son de excelente calidad y el proceso de compra es súper fácil.',
        service: 'Compra de Productos',
        date: '2024-08-15',
        status: 'aprobado'
      },
      {
        id: 2,
        name: 'Carlos R.',
        category: 'ecommerce',
        rating: 5,
        message: 'Excelente experiencia de compra. Los productos llegaron en perfecto estado y la atención al cliente es excepcional.',
        service: 'Marketplace',
        date: '2024-08-10',
        status: 'aprobado'
      },
      {
        id: 3,
        name: 'Ana L.',
        category: 'yoga',
        rating: 5,
        message: 'La plataforma de bienestar de Javiland cambió mi vida. Los programas de yoga y las comidas conscientes me han ayudado mucho.',
        service: 'Programa de Bienestar',
        date: '2024-08-12',
        status: 'aprobado'
      },
      {
        id: 4,
        name: 'Roberto M.',
        category: 'yoga',
        rating: 4,
        message: 'Excelente plataforma para el progreso personal. Los ayunos y movimientos de yoga están muy bien estructurados.',
        service: 'Salud Integral',
        date: '2024-08-08',
        status: 'aprobado'
      },
      {
        id: 5,
        name: 'TechStart Colombia',
        category: 'product',
        rating: 5,
        message: 'Product Studio superó nuestras expectativas. El desarrollo de nuestra aplicación fue impecable y el equipo muy profesional.',
        service: 'Desarrollo de App',
        date: '2024-08-14',
        status: 'aprobado'
      },
      {
        id: 6,
        name: 'EcoFashion Store',
        category: 'product',
        rating: 5,
        message: 'La solución tecnológica que desarrollaron para nosotros es perfecta. Optimizaron todos nuestros procesos empresariales.',
        service: 'Solución Tecnológica',
        date: '2024-08-06',
        status: 'aprobado'
      },
      {
        id: 7,
        name: 'Eventos Corporativos S.A.',
        category: 'music',
        rating: 5,
        message: 'Javi Roots hizo que nuestro evento fuera inolvidable. La mezcla de reggae, salsa y sonidos andinos fue perfecta.',
        service: 'Evento Corporativo',
        date: '2024-08-11',
        status: 'aprobado'
      },
      {
        id: 8,
        name: 'Fiesta Privada',
        category: 'music',
        rating: 5,
        message: 'Contratamos a Javi Roots para nuestra celebración y fue espectacular. La experiencia musical de 2 horas fue increíble.',
        service: 'Celebración Privada',
        date: '2024-08-07',
        status: 'aprobado'
      }
    ];
  }
}

const testimonialsServiceSingleton = new TestimonialsService();
export default testimonialsServiceSingleton;
